import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=518d9837&scoped=true&"
import script from "./PopUp.vue?vue&type=script&lang=js&"
export * from "./PopUp.vue?vue&type=script&lang=js&"
import style0 from "./PopUp.vue?vue&type=style&index=0&id=518d9837&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d9837",
  null
  
)

export default component.exports